// extracted by mini-css-extract-plugin
export default {"event":"EventItem_event__c9B9q","actions":"EventItem_actions__z6n6t"};